/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import NumberFormat from "react-number-format";
// import Email from "react-email-autocomplete";

class JoinStepTwo extends Component {
  state = {};
  _onMobile = () => {
    const popupUrl =
      "https://www.aniplustv.com/aniplus2020Api/Join/join_2nd_1.asp";
    window.open(
      popupUrl,
      "certWindow",
      "width=450, height=600, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250"
    );
  };
  _onIpin = () => {
    const popupUrl =
      "https://www.aniplustv.com/aniplus2020Api/Join/join_2nd_ipin_1.asp";
    window.open(
      popupUrl,
      "certWindow",
      "width=450, height=600, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250"
    );
  };
  _goIpin = () => {
    window.open(
      "https://www.ok-name.co.kr/acs/on/personipin/ipin_personServiceIntro.jsp?menu_id=2&sebmunu_id=1",
      "",
      ""
    );
  };
  _goOkname = () => {
    window.open(
      "https://www.ok-name.co.kr/CommonSvl?tc=kcb.acs.non.mn.cmd.LandMainCmd",
      "",
      ""
    );
  };

  render() {
    return (
      <Fragment>
        <div className="login_content width6">
          <div className="login_padding">
            <div className="join_step">
              Step 2<span>/3</span>
            </div>
            <h1>
              실명(본인)인증
              <div>
                ANIPLUSTV.COM 에서는 신용평가가사에서 제공하는 안전한 방법을
                통해 회원님의 실명을 확인하고 있습니다.
                <br />
                입력하신 정보는 저희 사이트 내에 보관되거나 제 3자에게 제공되지
                않습니다.
              </div>
            </h1>

            <div style={{ height: 13 }}></div>
            {/*
            <div className="login_btn">
              <a style={{ cursor: "pointer " }} onClick={this._onIpin}>
                I-PIN 본인인증
              </a>
            </div>

            <div className="login_btn2">
              <a style={{ cursor: "pointer " }} onClick={this._goIpin}>
                아이핀(i-pin) 안내 바로가기
              </a>
            </div>
            */}
            <div style={{ height: 20 }}></div>
            <div className="login_btn">
              <a style={{ cursor: "pointer " }} onClick={this._onMobile}>
                휴대폰 본인인증
              </a>
            </div>
            <div className="login_btn2">
              <a style={{ cursor: "pointer " }} onClick={this._goOkname}>
                코리아크레딧뷰로(주) 바로가기{" "}
              </a>
            </div>
          </div>
        </div>
        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(JoinStepTwo));
